import alvara from "./components/alvara/container/alvara.form";
import VisualizarAlvara from "./components/alvara/container/visualizarAlvara.form";
import Home from "./container/obrasParticulares.home";
import ImprimirHabitese from "./components/habitese/container/imprimirHabitese.subform";
import ValidarHabitese from "./components/habitese/container/validarHabitese.subform";
import VisualizarHabitese from "./components/habitese/container/visualizarHabitese.subform";

const routes = [
  {
    name: "obrasParticulares",
    path: "/obrasParticulares",
    component: Home,
    breadCrumb: [{ text: "Obras Particulares" }],
  },
  {
    name: "obrasParticulares.imprimirHabitese",
    path: "/obrasParticulares/imprimirHabitese",
    component: ImprimirHabitese,
    breadCrumb: [
      { text: "Obras Particulares", link: "obrasParticulares" },
      { text: "Imprimir Habite-se" },
    ],
  },
  {
    name: "obrasParticulares.validarHabitese",
    path: "/obrasParticulares/validarHabitese",
    component: ValidarHabitese,
    breadCrumb: [
      { text: "Obras Particulares", link: "obrasParticulares" },
      { text: "Validar Habite-se" },
    ],
  },
  {
    name: "obrasParticulares.visualizarHabitese",
    path: "/obrasParticulares/validarHabitese/visualizar",
    component: VisualizarHabitese,
    breadCrumb: [
      { text: "Obras Particulares", link: "obrasParticulares" },
      { text: "Validar Habite-se", link: "obrasParticulares.validarHabitese" },
      { text: "Dados do Habite-se" },
    ],
  },
  {
    name: "obrasParticulares.validarAlvara",
    path: "/obrasparticulares/validaralvara",
    component: alvara,
    breadCrumb: [
      { text: "Obras Particulares", link: "obrasParticulares" },
      { text: "Alvará" },
    ],
  },
  {
    name: "obrasParticulares.imprimirAlvara",
    path: "/obrasparticulares/validaralvara?imprimir=true",
    component: alvara,
    breadCrumb: [
      { text: "Obras Particulares", link: "obrasParticulares" },
      { text: "Alvará" },
    ],
  },
  {
    name: "obrasParticulares.visualizarAlvara",
    path: "/obrasparticulares/visualizarAlvara",
    component: VisualizarAlvara,
    breadCrumb: [
      { text: "Obras Particulares", link: "obrasParticulares" },
      { text: "Visualizar Alvará" },
    ],
  },
];

export default routes;
